export default __webpack_public_path__ + "static/media/youWin.1f4e0f56.mp3";